// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    AccountAccountActivateUserDefaultResponse,
    AccountAccountGetPrescribersDefaultResponse,
    AccountAccountGetSitesDefaultResponse,
    AccountAccountGetTasksDefaultResponse,
    AccountAccountGetUsersDefaultResponse,
    AccountAccountRemovePrescriberDefaultResponse,
    AccountAccountRemoveSiteDefaultResponse,
    AccountAccountSavePrescriberDefaultResponse,
    AccountAccountSaveSiteDefaultResponse,
    AccountAccountSaveTaskDefaultResponse,
    AccountAccountSaveUserDefaultResponse,
    AccountAccountSaveUserRoleDefaultResponse,
    AccountAccountUpdateAccountDefaultResponse,
    AccountAccountUpdateContactPreferencesDefaultResponse,
    AccountAttestationAttributeSaveModelV2,
    AccountExternalIdSaveThirdPartyIdResponse,
    AccountSaveModel,
    AccountSaveUserSaveUserRequestModel,
    AccountV1AccountV1PatientUpsearchDefaultResponse,
    AccountV2AttestationsUpdateAttestationResponse,
    AccountV2PrescribersHubGetPrescribersResponse,
    AccountV2SitesHubGetSitesResponse,
    AccountV2SitesSiteRequestModel,
    ExternalIdRequestModel,
    GatewayError,
    IActivateUserRequestModel,
    IGetTasksRequestModel,
    ISaveUserRoleRequestModel,
    IUpdateContactPreferencesModel,
    NoteTaskCreateModel,
    PatientUpSearchRequestModel,
    PrescriberUpsearchModel,
    PrescribersRequestModel,
    RemovePrescriberRequestModel,
    RemoveSiteRequestModel,
    SaveThirdPartyIdRequestModel,
    SiteUpsearchModel,
    SiteV3ClientGeneratedSiteUpsearchModel,
    TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel,
    TCApiGatewayControllersAccountModelsPrescriberUpsearchModel,
    TCApiGatewayControllersAccountModelsRemoveByIdRequest,
    TCApiGatewayControllersAccountModelsSearchByIdsRequest,
    TCApiGatewayControllersModelsRequestTypesExternalIdRequestModel,
    TCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeAccountApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param iActivateUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountActivateUser (iActivateUserRequestModel: IActivateUserRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountActivateUserDefaultResponse>> {
        const _url_ = '/edge/account/ActivateUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iActivateUserRequestModel' is not null or undefined
        if (iActivateUserRequestModel === null || iActivateUserRequestModel === undefined) {
            throw new Error('Required parameter iActivateUserRequestModel was null or undefined when calling accountActivateUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iActivateUserRequestModel, "IActivateUserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountActivateUserDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountActivateUserDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesExternalIdRequestModel 
     */
    public async accountExternalId (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesExternalIdRequestModel?: TCApiGatewayControllersModelsRequestTypesExternalIdRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/externalId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesExternalIdRequestModel, "TCApiGatewayControllersModelsRequestTypesExternalIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetPrescribers (body: object, xProgramId?: string): Promise<AxiosResponse<AccountAccountGetPrescribersDefaultResponse>> {
        const _url_ = '/edge/account/GetPrescribers';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetPrescribers.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountGetPrescribersDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountGetPrescribersDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetPrescribers_1 (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/getPrescribers';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetSites (body: object, xProgramId?: string): Promise<AxiosResponse<AccountAccountGetSitesDefaultResponse>> {
        const _url_ = '/edge/account/GetSites';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetSites.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountGetSitesDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountGetSitesDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetSites_2 (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/getSites';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param iGetTasksRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetTasks (iGetTasksRequestModel: IGetTasksRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountGetTasksDefaultResponse>> {
        const _url_ = '/edge/account/GetTasks';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iGetTasksRequestModel' is not null or undefined
        if (iGetTasksRequestModel === null || iGetTasksRequestModel === undefined) {
            throw new Error('Required parameter iGetTasksRequestModel was null or undefined when calling accountGetTasks.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iGetTasksRequestModel, "IGetTasksRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountGetTasksDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountGetTasksDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountGetUsers (body: object, xProgramId?: string): Promise<AxiosResponse<AccountAccountGetUsersDefaultResponse>> {
        const _url_ = '/edge/account/GetUsers';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetUsers.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountGetUsersDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountGetUsersDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsSearchByIdsRequest 
     */
    public async accountHubGetPrescribers (xProgramId?: string, tCApiGatewayControllersAccountModelsSearchByIdsRequest?: TCApiGatewayControllersAccountModelsSearchByIdsRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/hubGetPrescribers';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsSearchByIdsRequest, "TCApiGatewayControllersAccountModelsSearchByIdsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsSearchByIdsRequest 
     */
    public async accountHubGetSites (xProgramId?: string, tCApiGatewayControllersAccountModelsSearchByIdsRequest?: TCApiGatewayControllersAccountModelsSearchByIdsRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/hubGetSites';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsSearchByIdsRequest, "TCApiGatewayControllersAccountModelsSearchByIdsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsPatientUpSearchRequestModel 
     */
    public async accountPatientUpSearch (xProgramId?: string, tCApiGatewayControllersAccountModelsPatientUpSearchRequestModel?: TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/patientUpSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsPatientUpSearchRequestModel, "TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param removePrescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountRemovePrescriber (removePrescriberRequestModel: RemovePrescriberRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountRemovePrescriberDefaultResponse>> {
        const _url_ = '/edge/account/RemovePrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'removePrescriberRequestModel' is not null or undefined
        if (removePrescriberRequestModel === null || removePrescriberRequestModel === undefined) {
            throw new Error('Required parameter removePrescriberRequestModel was null or undefined when calling accountRemovePrescriber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(removePrescriberRequestModel, "RemovePrescriberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountRemovePrescriberDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountRemovePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsRemoveByIdRequest 
     */
    public async accountRemovePrescriber_3 (xProgramId?: string, tCApiGatewayControllersAccountModelsRemoveByIdRequest?: TCApiGatewayControllersAccountModelsRemoveByIdRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/removePrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsRemoveByIdRequest, "TCApiGatewayControllersAccountModelsRemoveByIdRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param removeSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountRemoveSite (removeSiteRequestModel: RemoveSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountRemoveSiteDefaultResponse>> {
        const _url_ = '/edge/account/RemoveSite';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'removeSiteRequestModel' is not null or undefined
        if (removeSiteRequestModel === null || removeSiteRequestModel === undefined) {
            throw new Error('Required parameter removeSiteRequestModel was null or undefined when calling accountRemoveSite.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(removeSiteRequestModel, "RemoveSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountRemoveSiteDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountRemoveSiteDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsRemoveByIdRequest 
     */
    public async accountRemoveSite_4 (xProgramId?: string, tCApiGatewayControllersAccountModelsRemoveByIdRequest?: TCApiGatewayControllersAccountModelsRemoveByIdRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/removeSite';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsRemoveByIdRequest, "TCApiGatewayControllersAccountModelsRemoveByIdRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param prescriberUpsearchModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountSavePrescriber (prescriberUpsearchModel: PrescriberUpsearchModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountSavePrescriberDefaultResponse>> {
        const _url_ = '/edge/account/SavePrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberUpsearchModel' is not null or undefined
        if (prescriberUpsearchModel === null || prescriberUpsearchModel === undefined) {
            throw new Error('Required parameter prescriberUpsearchModel was null or undefined when calling accountSavePrescriber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberUpsearchModel, "PrescriberUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountSavePrescriberDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountSavePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersAccountModelsPrescriberUpsearchModel 
     */
    public async accountSavePrescriber_5 (xProgramId?: string, tCApiGatewayControllersAccountModelsPrescriberUpsearchModel?: TCApiGatewayControllersAccountModelsPrescriberUpsearchModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/savePrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersAccountModelsPrescriberUpsearchModel, "TCApiGatewayControllersAccountModelsPrescriberUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param siteUpsearchModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountSaveSite (siteUpsearchModel: SiteUpsearchModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountSaveSiteDefaultResponse>> {
        const _url_ = '/edge/account/SaveSite';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteUpsearchModel' is not null or undefined
        if (siteUpsearchModel === null || siteUpsearchModel === undefined) {
            throw new Error('Required parameter siteUpsearchModel was null or undefined when calling accountSaveSite.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteUpsearchModel, "SiteUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountSaveSiteDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountSaveSiteDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param siteV3ClientGeneratedSiteUpsearchModel 
     */
    public async accountSaveSite_6 (xProgramId?: string, siteV3ClientGeneratedSiteUpsearchModel?: SiteV3ClientGeneratedSiteUpsearchModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/saveSite';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteV3ClientGeneratedSiteUpsearchModel, "SiteV3ClientGeneratedSiteUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param noteTaskCreateModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountSaveTask (noteTaskCreateModel: NoteTaskCreateModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountSaveTaskDefaultResponse>> {
        const _url_ = '/edge/account/SaveTask';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'noteTaskCreateModel' is not null or undefined
        if (noteTaskCreateModel === null || noteTaskCreateModel === undefined) {
            throw new Error('Required parameter noteTaskCreateModel was null or undefined when calling accountSaveTask.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(noteTaskCreateModel, "NoteTaskCreateModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountSaveTaskDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountSaveTaskDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountSaveUserSaveUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountSaveUser (accountSaveUserSaveUserRequestModel: AccountSaveUserSaveUserRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountSaveUserDefaultResponse>> {
        const _url_ = '/edge/account/SaveUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountSaveUserSaveUserRequestModel' is not null or undefined
        if (accountSaveUserSaveUserRequestModel === null || accountSaveUserSaveUserRequestModel === undefined) {
            throw new Error('Required parameter accountSaveUserSaveUserRequestModel was null or undefined when calling accountSaveUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountSaveUserSaveUserRequestModel, "AccountSaveUserSaveUserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountSaveUserDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountSaveUserDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iSaveUserRoleRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountSaveUserRole (iSaveUserRoleRequestModel: ISaveUserRoleRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountSaveUserRoleDefaultResponse>> {
        const _url_ = '/edge/account/SaveUserRole';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iSaveUserRoleRequestModel' is not null or undefined
        if (iSaveUserRoleRequestModel === null || iSaveUserRoleRequestModel === undefined) {
            throw new Error('Required parameter iSaveUserRoleRequestModel was null or undefined when calling accountSaveUserRole.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iSaveUserRoleRequestModel, "ISaveUserRoleRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountSaveUserRoleDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountSaveUserRoleDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountSaveModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountUpdateAccount (accountSaveModel: AccountSaveModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountUpdateAccountDefaultResponse>> {
        const _url_ = '/edge/account/UpdateAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountSaveModel' is not null or undefined
        if (accountSaveModel === null || accountSaveModel === undefined) {
            throw new Error('Required parameter accountSaveModel was null or undefined when calling accountUpdateAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountSaveModel, "AccountSaveModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountUpdateAccountDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountUpdateAccountDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iUpdateContactPreferencesModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountUpdateContactPreferences (iUpdateContactPreferencesModel: IUpdateContactPreferencesModel, xProgramId?: string): Promise<AxiosResponse<AccountAccountUpdateContactPreferencesDefaultResponse>> {
        const _url_ = '/edge/account/UpdateContactPreferences';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iUpdateContactPreferencesModel' is not null or undefined
        if (iUpdateContactPreferencesModel === null || iUpdateContactPreferencesModel === undefined) {
            throw new Error('Required parameter iUpdateContactPreferencesModel was null or undefined when calling accountUpdateContactPreferences.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iUpdateContactPreferencesModel, "IUpdateContactPreferencesModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountAccountUpdateContactPreferencesDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountAccountUpdateContactPreferencesDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientUpSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountV1PatientUpsearch (patientUpSearchRequestModel: PatientUpSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountV1AccountV1PatientUpsearchDefaultResponse>> {
        const _url_ = '/edge/account/v1/PatientUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientUpSearchRequestModel' is not null or undefined
        if (patientUpSearchRequestModel === null || patientUpSearchRequestModel === undefined) {
            throw new Error('Required parameter patientUpSearchRequestModel was null or undefined when calling accountV1PatientUpsearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientUpSearchRequestModel, "PatientUpSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountV1AccountV1PatientUpsearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV1AccountV1PatientUpsearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountId 
     * @param accountAttestationAttributeSaveModelV2 default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async attestationsUpdateAttestation (accountId: number, accountAttestationAttributeSaveModelV2: AccountAttestationAttributeSaveModelV2, xProgramId?: string): Promise<AxiosResponse<AccountV2AttestationsUpdateAttestationResponse>> {
        const _url_ = '/edge/account/v2/Attestations/updateAttestation/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling attestationsUpdateAttestation.');
        }

        // verify required parameter 'accountAttestationAttributeSaveModelV2' is not null or undefined
        if (accountAttestationAttributeSaveModelV2 === null || accountAttestationAttributeSaveModelV2 === undefined) {
            throw new Error('Required parameter accountAttestationAttributeSaveModelV2 was null or undefined when calling attestationsUpdateAttestation.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountAttestationAttributeSaveModelV2, "AccountAttestationAttributeSaveModelV2"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountV2AttestationsUpdateAttestationResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2AttestationsUpdateAttestationResponse");
        }
        return response;
    }
    /**
     * 
     * @param externalIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async externalIdExternalId (externalIdRequestModel: ExternalIdRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountExternalIdSaveThirdPartyIdResponse>> {
        const _url_ = '/edge/account/ExternalId/externalId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'externalIdRequestModel' is not null or undefined
        if (externalIdRequestModel === null || externalIdRequestModel === undefined) {
            throw new Error('Required parameter externalIdRequestModel was null or undefined when calling externalIdExternalId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(externalIdRequestModel, "ExternalIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountExternalIdSaveThirdPartyIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountExternalIdSaveThirdPartyIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param saveThirdPartyIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async externalIdSaveThirdPartyId (saveThirdPartyIdRequestModel: SaveThirdPartyIdRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountExternalIdSaveThirdPartyIdResponse>> {
        const _url_ = '/edge/account/ExternalId/saveThirdPartyId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'saveThirdPartyIdRequestModel' is not null or undefined
        if (saveThirdPartyIdRequestModel === null || saveThirdPartyIdRequestModel === undefined) {
            throw new Error('Required parameter saveThirdPartyIdRequestModel was null or undefined when calling externalIdSaveThirdPartyId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(saveThirdPartyIdRequestModel, "SaveThirdPartyIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountExternalIdSaveThirdPartyIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountExternalIdSaveThirdPartyIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel 
     */
    public async externalIdSaveThirdPartyId_7 (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel?: TCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Account/externalId/saveThirdPartyId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel, "TCApiGatewayControllersModelsRequestTypesSaveThirdPartyIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param prescribersRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async prescribersHubGetPrescribers (prescribersRequestModel: PrescribersRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountV2PrescribersHubGetPrescribersResponse>> {
        const _url_ = '/edge/account/v2/Prescribers/HubGetPrescribers';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescribersRequestModel' is not null or undefined
        if (prescribersRequestModel === null || prescribersRequestModel === undefined) {
            throw new Error('Required parameter prescribersRequestModel was null or undefined when calling prescribersHubGetPrescribers.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescribersRequestModel, "PrescribersRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountV2PrescribersHubGetPrescribersResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2PrescribersHubGetPrescribersResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountV2SitesSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async sitesHubGetSites (accountV2SitesSiteRequestModel: AccountV2SitesSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<AccountV2SitesHubGetSitesResponse>> {
        const _url_ = '/edge/account/v2/Sites/HubGetSites';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountV2SitesSiteRequestModel' is not null or undefined
        if (accountV2SitesSiteRequestModel === null || accountV2SitesSiteRequestModel === undefined) {
            throw new Error('Required parameter accountV2SitesSiteRequestModel was null or undefined when calling sitesHubGetSites.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountV2SitesSiteRequestModel, "AccountV2SitesSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AccountV2SitesHubGetSitesResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2SitesHubGetSitesResponse");
        }
        return response;
    }
}
